import { LEGAL_DOCS, type LegalDocKey } from '../lib/legalDocs';

interface LegalDocViewProps {
  doc: LegalDocKey;
}

/** "제N조(...)" 패턴 줄을 소제목으로 인식. */
const ARTICLE_RE = /^제\s*\d+\s*조/;

/**
 * 법무 문서 읽기 전용 뷰어.
 * - 좁은 readable 폭 + 넉넉한 행간으로 가독성 확보.
 * - 조문(제N조)은 소제목으로 강조, 빈 줄은 간격으로 처리.
 */
export function LegalDocView({ doc }: LegalDocViewProps) {
  // version 은 곧 시행일이다 — 동의 기록에 실리는 값과 화면에 보이는 값이 같아야 한다.
  const { title, version, body } = LEGAL_DOCS[doc];
  const lines = body.split('\n');

  return (
    <article className="mx-auto max-w-3xl px-4 py-12 sm:py-16">
      <header className="border-b border-neutral-200 dark:border-white/15 pb-5">
        <h1 className="text-2xl font-bold text-neutral-900 dark:text-neutral-100 sm:text-3xl">
          {title}
        </h1>
        <p className="mt-2 text-sm text-neutral-500 dark:text-neutral-400">
          시행일 {version}
        </p>
      </header>

      <div className="mt-8 text-[15px] leading-7 text-neutral-700 dark:text-neutral-300">
        {lines.map((line, i) => {
          const trimmed = line.trim();
          if (trimmed === '')
            return <div key={i} className="h-3" aria-hidden />;
          if (ARTICLE_RE.test(trimmed)) {
            return (
              <h2
                key={i}
                className="mt-8 mb-2 scroll-mt-24 text-base font-semibold text-neutral-900 dark:text-neutral-100"
              >
                {line}
              </h2>
            );
          }
          return (
            <p key={i} className="whitespace-pre-wrap">
              {line}
            </p>
          );
        })}
      </div>
    </article>
  );
}
